import { render, staticRenderFns } from "./yhMemberActivitiesManageList.vue?vue&type=template&id=4a044969&"
import script from "./yhMemberActivitiesManageList.vue?vue&type=script&lang=js&"
export * from "./yhMemberActivitiesManageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports